// tableSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { slice } from '../../../enums';

interface TableState {
    forceRefetch?: boolean; // used to force refetch data
}

const initialState: TableState = {
    forceRefetch: false,
 };

const tableSlice = createSlice({
  name: slice.FORM,
  initialState,
  reducers: {

    forceRefetchData: (state) => {

       state.forceRefetch = !state.forceRefetch;
     },
     
 
  },
});

export const { forceRefetchData} = tableSlice.actions;
export const tableReducer = tableSlice.reducer;
 